"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
const formik_1 = require("formik");
function SuccessOverlay({ children, closable = true }) {
    const { status, setStatus } = (0, formik_1.useFormikContext)();
    if (!status) {
        return null;
    }
    function handleClick() {
        setStatus(false);
    }
    return ((0, preact_1.h)("div", { className: 'absolute inset-0 z-10 flex items-center justify-center' },
        (0, preact_1.h)("div", { className: 'w-full max-w-xl bg-teal text-white text-center drop-shadow-2xl' },
            (0, preact_1.h)("div", { className: 'px-6 sm:px-8 py-10 md:py-12' },
                children,
                closable && ((0, preact_1.h)("div", { className: 'mt-5 md:mt-7' },
                    (0, preact_1.h)("button", { type: 'button', onClick: handleClick, className: 'inline-block border-2 border-white py-3.5 px-16 font-heading text-lg leading-none uppercase transition-colors hover:bg-white hover:text-teal' }, "Close")))))));
}
exports.default = SuccessOverlay;
SuccessOverlay.Heading = Heading;
SuccessOverlay.Content = Content;
function Heading({ children }) {
    return ((0, preact_1.h)("h3", { className: 'font-heading text-3xl md:text-4xl leading-slim md:leading-slim uppercase' }, children));
}
function Content({ children }) {
    return ((0, preact_1.h)("div", { className: 'max-w-xs mx-auto md:max-w-none mt-2 sm:mt-3 type sm:text-lg text-balance' }, children));
}
